// extracted by mini-css-extract-plugin
module.exports = {"logoWrapper":"Logo_logoWrapper__1jCDS"};